import { Paper, Skeleton, Stack } from '@mantine/core';

interface KpiSkeletonProps {
  height?: number;
  rows?: number;
  columns?: number;
}

/**
 * Skeleton for KPI components during loading/streaming states.
 * Shows a value placeholder with label below, matching Kpi visual proportions.
 */
export function KpiSkeleton({ height: _height, rows: _rows, columns: _columns }: KpiSkeletonProps) {
  return (
    <Paper p="md" radius="sm" withBorder>
      <Stack gap="xs">
        <Skeleton animate height={40} radius="sm" width="70%" />
        <Skeleton animate height={16} radius="sm" width="50%" />
        <Skeleton animate height={12} radius="sm" width="30%" />
      </Stack>
    </Paper>
  );
}
